import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/api";
import { useAuth } from "@/AuthContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Briefcase, Loader2, Save } from "lucide-react";
import { MetierPicker } from "@/components/metiers/MetierPicker";
import { loadMetiers } from "@/components/metiers/metierUtils";

/** Phase 89 — profil gérant : métier principal (verrouillé, modifiable par PAG) + métiers secondaires (libres). */
export const ChefMetiersCard = () => {
  const { user, refreshUser } = useAuth();
  const ent = user?.entreprise || {};
  const [secs, setSecs] = useState(ent.metiers_secondaires || []);
  const [principal, setPrincipal] = useState(ent.metier_code || null);
  const [ref, setRef] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { setSecs(ent.metiers_secondaires || []); setPrincipal(ent.metier_code || null); }, [ent.metier_code, ent.metiers_secondaires]);
  useEffect(() => { loadMetiers().then((ms) => setRef(Object.fromEntries(ms.map((m) => [m.code, m])))).catch(() => {}); }, []);
  const dirty = JSON.stringify(secs) !== JSON.stringify(ent.metiers_secondaires || []) || principal !== (ent.metier_code || null);
  const save = async () => {
    setBusy(true);
    try { await api.post("/chef/entreprise/metiers", { metier_code: principal, metiers_secondaires: secs }); toast.success("Métiers enregistrés"); await refreshUser(); window.dispatchEvent(new Event("pag:modules-changed")); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Enregistrement impossible"); } finally { setBusy(false); }
  };
  const p = ref[principal];
  return (
    <div className="bg-white border border-[#DEE2E6] p-6" data-testid="profile-metiers-card">
      <div className="flex items-center gap-2 mb-3"><Briefcase className="h-4 w-4 text-[#002FA7]" /><h3 className="font-display font-bold text-base">Modules métier</h3></div>
      <div className="text-xs text-[#495057] mb-3" data-testid="profile-metier-principal">
        {p ? <>Métier principal : <b>{p.emoji} {p.label}</b> <span className="font-mono text-[10px] text-[#868E96]">{p.code}</span> — modifiable par PAG Helper. Ajoutez vos métiers secondaires pour débloquer leurs modules (ex. hôtel + restaurant).</> : <>Aucun métier défini : choisissez votre métier principal pour activer les modules adaptés.</>}
      </div>
      <MetierPicker value={principal} onChange={setPrincipal} secondaires={secs} onSecondairesChange={setSecs} lockPrincipal={Boolean(ent.metier_code)} compact testid="profile-metier" />
      <div className="flex justify-end mt-3"><Button onClick={save} disabled={busy || !dirty || !principal} className="h-10 bg-[#002FA7] hover:bg-[#002175] text-white font-semibold" data-testid="profile-metiers-save">{busy ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Save className="h-4 w-4 mr-2" />}Enregistrer mes métiers</Button></div>
    </div>
  );
};
